module.exports = __webpack_public_path__ + "word_map.925633f6715929c667b2.png";


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/assets/img/landing/word_map.png
// module id = ../../../../../src/assets/img/landing/word_map.png
// module chunks = 1